export const DayOfWeekValues = {
    SUNDAY: 0,
    MONDAY: 1,
    TUESDAY: 2,
    WEDNESDAY: 3,
    THURSDAY: 4,
    FRIDAY: 5,
    SATURDAY: 6,
} as const;

export type DayOfWeekValue = typeof DayOfWeekValues[keyof typeof DayOfWeekValues];

export class DayOfWeek {

    constructor(public readonly value: DayOfWeekValue) {}

}
